import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

import {
  PURHCASE_CREDITS,
  TRANSFER_CREDITS,
  WITHDRAW_CREDITS,
} from '../constants';

const apiStates = [
  ...restApiStates(['credits'], 'credit'),
  { type: PURHCASE_CREDITS, name: 'credit', prepend: 'credits' },
  { type: TRANSFER_CREDITS, name: 'credit', prepend: 'credits' },
  { type: WITHDRAW_CREDITS, name: 'credit', prepend: 'credits' },
];

const instantStates = [];
const storage = {};
const listValues = ['credits'];

const reducer = generateHandleActions({ apiStates, instantStates, storage, listValues });
export default reducer;
